<template>
  <v-card :ref="'refDeviceStatus' + item.sn" :style="canBeEdit || isInEditMode ? '' : 'opacity: 0.3;'" justify="start" class="ma-0 pa-0" outlined elevation="3" style="max-width: 1100px" :height="editDeviceItemHeight - 8">
    <v-card-title class="ma-1 pa-0" align="left">
      <v-row class="ma-0 pa-0 pl-3 pt-1" justify="start" align="center">
        <v-col v-if="item.Status" sm="3" md="5" xl="5" cols="3" class="ma-0 pa-0">
          <v-badge avatar overlap left color="transparent">
            <template v-slot:badge>
              <v-avatar>
                <v-icon small :color="item.Status.Color">{{ item.Status.Icon }}</v-icon>
              </v-avatar>
            </template>
            <v-avatar size="40" tile>
              <v-img :src="item.Image" width="auto" height="auto" contain></v-img>
            </v-avatar>
          </v-badge>
          <span v-if="!isOnMobile" class="subtitle-2 ml-2">
            Статус:
            <span class="subtitle-2" :style="`color: ${item.Status.Color}`">{{ item.Status.Text }}</span>
          </span>
          <v-tooltip v-if="item.sim.activatedMo == false" :disabled="!userSettings.showTooltips || isOnAndroid" bottom style="z-index: 10">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small right class="ma-0 pa-0 ml-2" color="error">mdi-sim-off</v-icon>
            </template>
            {{ TR.DevWithStoppedSim }}
          </v-tooltip>
        </v-col>
        <v-col sm="9" md="7" xl="7" cols="9" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 box-container-horizontal" align="center" justify="center">
            <div class="ma-0 pa-0 row-content" style="overflow: hidden">
              <span v-if="isUserObserver() || !item.duprofile.cosmosableDevice || !isInEditMode" class="subtitle-1" style="white-space: no">{{ item.Name }}</span>
              <div v-else class="ma-0 pa-0">
                <v-text-field class="ma-0 pa-0" :placeholder="item.Name" clearable v-model="item.Name" dense single-line clear-icon="mdi-close-circle-outline" hide-details></v-text-field>
                <t-divider></t-divider>
              </div>
            </div>
            <div class="ma-0 pa-0 row-header" v-if="!isUserObserver() && item.duprofile.cosmosableDevice">
              <v-btn v-if="isInEditMode" class="ma-2 pa-0" small icon @click="changeDevName(item)">
                <v-tooltip :disabled="hideTooltips" top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-check</v-icon>
                  </template>
                  <span>{{ TR.SaveChanges }}</span>
                </v-tooltip>
              </v-btn>
              <v-btn v-else-if="canBeEdit" class="ma-2 pa-0" small icon @click="setEditMode(true)">
                <v-tooltip :disabled="hideTooltips" top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-pencil</v-icon>
                  </template>
                  <span>{{ TR.EditInfo }}</span>
                </v-tooltip>
              </v-btn>
            </div>
          </v-row>
        </v-col>
        <v-col class="ma-0 pa-0"></v-col>
      </v-row>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="text-align: left" class="ma-0 pa-2">
      <v-row class="ma-0 pa-0">
        <v-col cols="12" sm="12" md="6" lg="6" xl="5" xs="12" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 34px">
            <v-col class="ma-0 pa-0" cols="4">
              <span class="text-no-wrap">{{ TR.DevNumber }}</span>
            </v-col>
            <v-col class="ma-0 pa-0" cols="8">
              <span class="text-no-wrap">{{ item.sn }}</span>
            </v-col>
          </v-row>
          <v-divider class="mr-1"></v-divider>
          <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 34px">
            <v-col class="ma-0 pa-0" cols="4">
              <span class="text-no-wrap">{{ TR.Model }}</span>
            </v-col>
            <v-col class="ma-0 pa-0" cols="8">
              <span style="cursor: pointer; text-decoration: underline" @click="openTremolSite(item.model.name)">{{ item.model.name }}</span>
              <span v-if="!item.duprofile.cosmosableDevice">*</span>
            </v-col>
          </v-row>
          <v-divider class="mr-1"></v-divider>
        </v-col>

        <v-col cols="12" sm="12" md="6" lg="6" xl="5" xs="12" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 34px">
            <v-col class="ma-0 pa-0" cols="4">
              <span class="text-no-wrap">{{ TR.Activity }}</span>
            </v-col>
            <v-col class="ma-0 pa-0" cols="8">
              <span v-if="item.duprofile.cosmosableDevice && item.duprofile.cosmosDevice">{{ new Date(item.lastTalkDate).toTremolFpString() }}</span>
              <span v-else>
                {{ TR.Missing }}
                <span v-if="!item.duprofile.cosmosableDevice">*</span>
              </span>
            </v-col>
          </v-row>
          <v-divider class="mr-1"></v-divider>
          <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 34px">
            <v-col class="ma-0 pa-0" cols="4">
              <span class="text-no-wrap">{{ TR.Contract }}</span>
            </v-col>
            <v-col class="ma-0 pa-0" cols="8">
              <span class="text-no-wrap">{{ new Date(item.currServContrExpDate).toTremolFpStringShort() }}</span>
            </v-col>
          </v-row>
          <v-divider class="mr-1"></v-divider>
        </v-col>

        <v-col cols="12" sm="12" md="6" lg="6" xl="5" xs="12" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 34px">
            <v-col class="ma-0 pa-0" cols="4">
              <span class="text-no-wrap">{{ TR.Company }}</span>
            </v-col>
            <v-col class="ma-0 pa-0" cols="8">
              <div class="box-container-horizontal">
                <span class="text-no-wrap row-content" :style="isOnMobile ? 'scrollbar-width: thin;' : 'overflow: hidden;'">{{ item.client.orgName }}</span>
              </div>
            </v-col>
          </v-row>
          <v-divider class="mr-1"></v-divider>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6" xl="5" xs="12" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 34px">
            <v-col class="ma-0 pa-0" cols="4">
              <span class="text-no-wrap">{{ TR.Address }}</span>
            </v-col>
            <v-col class="ma-0 pa-0" cols="8">
              <div class="box-container-horizontal">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on" class="text-no-wrap row-content" :style="isOnMobile ? 'scrollbar-width: thin;' : 'overflow: hidden;'" style="cursor: pointer; text-decoration: underline" @click="showModalMap(item.Address)">
                      <v-icon small left>mdi-map-marker-radius-outline</v-icon>
                      {{ item.Address ? item.Address.replace("България, ", "") : "" }}
                    </span>
                  </template>
                  <span>{{ item.Address }}</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
          <v-divider class="mr-1"></v-divider>
        </v-col>
        <template v-if="item.duprofile.cosmosableDevice">
          <v-col cols="12" sm="12" md="6" lg="6" xl="5" xs="12" class="ma-0 pa-0">
            <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 36px">
              <v-col class="ma-0 pa-0" cols="4">
                <span class="text-no-wrap">{{ isOnMobile ? TR.PSN : TR.PSName }}</span>
              </v-col>
              <v-col class="ma-0 pa-0" cols="8" justify="space-between">
                <div class="box-container-horizontal ma-0 pa-0">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" v-if="!isInEditMode" class="text-no-wrap subtitle-1 row-content" :style="isOnMobile ? 'scrollbar-width: thin;' : 'overflow: hidden;'">{{ item.PSName }}</span>
                    </template>
                    <span>{{ item.PSName }}</span>
                  </v-tooltip>
                  <div class="row-content ma-0 pa-0" v-if="isInEditMode">
                    <v-text-field class="ma-0 pa-0" v-model="item.PSName" :style="isOnMobile ? 'scrollbar-width: thin;' : 'overflow: hidden;'" :placeholder="item.PSName" hide-details dense single-line></v-text-field>
                    <t-divider></t-divider>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-divider class="mr-1"></v-divider>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="5" xs="12" class="ma-0 pa-0">
            <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 36px">
              <v-col class="ma-0 pa-0" cols="4">
                <span class="text-no-wrap">{{ TR.Subscription }}</span>
              </v-col>
              <v-col class="ma-0 pa-0" cols="8">
                <v-row class="ma-0 pa-0" justify="start" align="center">
                  <v-btn v-if="!isUserObserver() && (!item.duprofile.csubscriptionPlan || item.duprofile.csubscriptionPlan.id == -1)" class="ma-2 success white--text" tile outlined x-small @click.stop="selectDeviceForSubscription(item)">{{
                    isOnMobile ? TR.Activate : TR.ActivatePlan
                  }}</v-btn>
                  <v-tooltip v-else :disabled="!userSettings.showTooltips || isOnAndroid" bottom>
                    <template v-slot:activator="{ on }">
                      <v-menu transition="scroll-y-transition" v-on="on">
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="!isUserObserver() && on" class="white--text" tile :color="item.duprofile.cosmosDevice ? 'success' : 'error'" outlined small>{{
                            item.duprofile.cosmosDevice && item.duprofile.csubscriptionPlan ? item.duprofile.csubscriptionPlan.name : TR.Missing
                          }}</v-btn>
                        </template>
                        <v-card>
                          <v-row class="ma-0 pa-0 px-1" justify="center" align="center">
                            <v-btn style="background-color: #ffb300" class="ma-2 white--text" tile outlined small @click.stop="selectDeviceForSubscription(item)">{{ isOnMobile ? TR.Change : TR.ChangePlan }}</v-btn>
                          </v-row>
                          <v-row class="ma-0 pa-0 px-1" justify="center" align="center">
                            <v-btn class="ma-2 error white--text" tile outlined small @click.stop="selectDeviceToUnsubscribe(item)">{{ isOnMobile ? TR.Deactivate : TR.DeactivatePlan }}</v-btn>
                          </v-row>
                        </v-card>
                      </v-menu>
                    </template>
                    <span v-if="item.duprofile.cosmosDevice && item.duprofile.csubscriptionPlan">{{ item.duprofile.csubscriptionPlan.description }}</span>
                  </v-tooltip>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mr-1"></v-divider>
          </v-col>

          <v-col cols="12" sm="12" :md="6" :lg="6" :xl="5" xs="12" class="ma-0 pa-0">
            <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 36px">
              <v-col class="ma-0 pa-0" cols="4" :md="4" :lg="4" :xl="4">
                <span class="text-no-wrap">{{ TR.Comment }}</span>
              </v-col>
              <v-col cols="8" :md="8" :lg="8" :xl="8" class="ma-0 pa-0" justify="space-between">
                <div class="box-container-horizontal">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" v-if="!isInEditMode" class="text-no-wrap subtitle-1 row-content" :style="isOnMobile ? 'scrollbar-width: thin;' : 'overflow: hidden;'">{{ item.Comment }}</span>
                    </template>
                    <span>{{ item.Comment }}</span>
                  </v-tooltip>
                  <div v-if="isInEditMode" class="row-content ma-0 pa-0">
                    <v-text-field class="ma-0 pa-0" v-model="item.Comment" :style="isOnMobile ? 'scrollbar-width: thin;' : 'overflow: hidden;'" :placeholder="item.Comment" dense single-line hide-details></v-text-field>
                    <t-divider></t-divider>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-divider class="mr-1"></v-divider>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="5" xs="12" class="ma-0 pa-0">
            <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 36px">
              <v-col class="ma-0 pa-0" cols="4">
                <span class="text-no-wrap">{{ TR.Technician }}</span>
              </v-col>
              <v-col cols="8" class="ma-0 pa-0" justify="space-between">
                <div class="box-container-horizontal">
                  <v-tooltip top v-if="item.Technician">
                    <template v-slot:activator="{ on }">
                      <span v-on="on" v-if="!isInEditMode" class="text-no-wrap subtitle-1 row-content" :style="isOnMobile ? 'scrollbar-width: thin;' : 'overflow: hidden;'">{{ item.Technician.n }}</span>
                    </template>
                    <span style="white-space: pre-line">{{ item.Technician.n + "\n" + item.Technician.p + "\n" + item.Technician.c }}</span>
                  </v-tooltip>
                  <div v-if="isInEditMode" class="row-content ma-0 pa-0">
                    <v-select
                      clearable
                      clear-icon="mdi-close"
                      class="ma-0 pa-0"
                      style="overflow: hidden"
                      :items="techs"
                      return-object
                      v-model="item.Technician"
                      item-text="name"
                      no-data-text="Не са добавени лица за поддръжка"
                      dense
                      single-line
                      hide-details
                    ></v-select>
                    <!-- <v-text-field class="ma-0 pa-0" v-model="item.Comment" :style="isOnMobile ? 'scrollbar-width: thin;' : 'overflow: hidden;'" :placeholder="item.Comment" dense single-line hide-details></v-text-field> -->
                    <t-divider></t-divider>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-divider class="mr-1"></v-divider>
          </v-col>
        </template>
        <v-col v-else cols="12" sm="12" md="12" lg="12" xl="10" xs="12" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 px-1 pt-6" justify="center" align="center" style="height: 36px">
            <span class="error--text" style="height: 100%">{{ "* " + TR.NoOnlineReports }}</span>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import DataManager, { ErrorMessage } from "../../js/DataManager";
import bus, { TR } from "../../main";

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    device: {
      type: Object,
    },
    technicians: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      item: this.device,
      techs: this.technicians,
      isInEditMode: this.editMode,
      canBeEdit: true,
      TR: TR,
    };
  },
  methods: {
    isUserObserver() {
      return DataManager.userHasAccess(DataManager.UserTypes.Observer);
    },
    showModalMap(devaddress, maplatlng) {
      this.dialog.show("google-map", null, {
        //this.$modal.show("modal-map", {
        address: devaddress,
        latlng: maplatlng,
      });
    },
    changeDevName(item) {
      DataManager.updateDevProfile(item, (err) => {
        if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
          this.dialogLoader.hide();
          this.dialogLoader.showInfo(TR.SaveSuccessful);
          this.setEditMode(false);
          if (this.editMode) {
            this.dialog.close();
          }
        } else {
          var msg = err.Message + "\n";
          if (err.ErrorDetails) {
            err.ErrorDetails.forEach((d) => (msg += d.Description + "\n"));
          }
          this.dialogLoader.showError(msg);
        }
      });
    },
    selectDeviceToUnsubscribe(item) {
      this.$router
        .push({ path: "/" + TR.Locale + "/subscription" })
        .catch(() => {})
        .then(() => {
          this.$nextTick(() => {
            bus.$emit(bus.EVENT_Device_want_to_unsubscribe, item);
          });
        });
    },
    selectDeviceForSubscription(item) {
      this.$router
        .push({ path: "/" + TR.Locale + "/subscription" })
        .catch(() => {})
        .then(() => {
          this.$nextTick(() => {
            bus.$emit(bus.EVENT_Device_want_to_subscribe, item);
          });
        });
    },
    setEditMode(newVal) {
      this.isInEditMode = newVal;
      if (newVal) {
        bus.$emit(bus.EVENT_Device_started_to_edit, DataManager.getData(DataManager.DataType.devices).indexOf(this.device));
      } else {
        bus.$emit(bus.EVENT_Device_started_to_edit, -1);
      }
    },
  },
  created() {
    if (this.techs == null) {
      this.techs = DataManager.getData(DataManager.DataType.user, true).settings2.technicians;
    }
  },
  mounted() {
    bus.$on(bus.EVENT_Device_started_to_edit, (idx) => {
      this.canBeEdit = idx == -1;
    });
    bus.$on(bus.EVENT_Device_selected_for_subscribtion, (dev) => {
      this.selectDeviceForSubscription(dev);
    });
  },
};
</script>

<style>
</style>
